import React from "react";
import { useTranslation } from "react-i18next";
import { cloneDeep } from "lodash";
import Input from "components/form/input/Input";
import { useFormBuilderEditorContext } from "../../../formBuilderEditorContext";
import { useFormBuilderDebouncedUpdate } from "../../../hooks/debouncedUpdate/useFormBuilderDebouncedUpdate";
import { IFormBuilderButton, TFormBuilderButtonSettings } from "../../../model/item/formBuilderButton";

interface IFormBuilderButtonSettingsProps {
  item: IFormBuilderButton;
}

export function FormBuilderButtonSettings(props: IFormBuilderButtonSettingsProps) {
  const { item } = props;

  const { t } = useTranslation();

  const { formBuilderController } = useFormBuilderEditorContext();

  const settings = item.data.settings;

  const debouncedLabel = useFormBuilderDebouncedUpdate<string>({
    defaultValue: "",
    value: settings.label,
  });

  function dispatchSettings(partialNextSettings: Partial<TFormBuilderButtonSettings>) {
    formBuilderController.updateItemSettings({
      key: item.key,
      prevItemSettings: {
        type: item.data.type,
        settings: cloneDeep(settings),
      },
      nextItemSettings: {
        type: item.data.type,
        settings: {
          ...cloneDeep(settings),
          ...partialNextSettings,
        },
      },
    });
  }

  return (
    <Input
      label={t("Label")}
      value={debouncedLabel.state.active ? debouncedLabel.state.value : settings.label}
      onFocus={debouncedLabel.activate}
      onChange={e => {
        debouncedLabel.change(e.target.value, label => {
          dispatchSettings({ label });
        });
      }}
      onBlur={() =>
        debouncedLabel.commit(label => {
          dispatchSettings({ label });
        })
      }
    />
  );
}
